import React from 'react';
import styled from 'styled-components';
import { Border, Overlay, Padding, Stack, Text, Quote } from '../../components';

const CoreValuesMissionWrapper = styled.div<any>`
  background-image: url(${({ url }) => url});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 575px;
  width: 100%;
`;

const DescriptionWrapper = styled.div<any>`
  display: flex;
  height: 100%;
  width: 100%;
`;

const Dimension = styled.div<any>`
  width: ${({ width }: any) => width};
`;

export const CoreValuesMissionDesktop = () => {
  return (
    <Overlay relative>
      <div style={{ width: '30vw', maxHeight: '900px' }}>
        <CoreValuesMissionWrapper url="images/about-glossier-1.jpg" />
      </div>
      <div style={{ width: '70vw', maxHeight: '900px' }}>
        <CoreValuesMissionWrapper url="images/about-glossier-2.jpg" />
      </div>
      <Overlay>
        <Padding size={[7, 0]} height="100%">
          <DescriptionWrapper>
            <Dimension width="18vw" />
            <Dimension width="320px">
              <Border borderSize={[2]} borderRole="white" radius="small">
                <Padding size={[5]} backgroundRole="white">
                  <Stack size={4}>
                    <Quote textType="quote" align="left">
                      Glossier is giving voice through beauty as a
                      direct-to-consumer company that leverages the power of
                      personal narrative to own the beauty conversation on the
                      internet.
                    </Quote>

                    <Text textType="primary2" align="left">
                      As a brand that puts skin first, Glossier is redefining
                      the beauty industry by fusing the insights of our
                      community with our beauty-editor expertise (rooted in
                      Glossier’s successful publication Into The Gloss) to
                      create a line of intuitive, enjoyable products that work
                      hard for you (not the other way around). Together, we’re
                      bringing the experience of shopping for (and talking
                      about) beauty into the future.
                    </Text>
                  </Stack>
                </Padding>
              </Border>
            </Dimension>
            <Dimension width="40vw" />
          </DescriptionWrapper>
        </Padding>
      </Overlay>
    </Overlay>
  );
};
